import React from 'react';
import { Route, Redirect, BrowserRouter as Router } from 'react-router-dom';
import Login from '../app/login/login';
import './app.module.scss';
import { LoginHelper } from './helpers';
import Main from './main-page/main-page';
import Policy from './policy/policy';
import SmsCallback from './sms-callback/sms-callback';

export function App() {
    const PrivateRoute = ({ component: Component, ...rest }) => (
        <Route
            {...rest}
            render={(props) => {
                const isAuth = LoginHelper.validateToken();
                return isAuth ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                );
            }}
        />
    );

    return (
        <Router>
            <Route exact path="/sms">
                <SmsCallback />
            </Route>
            <Route exact path="/policy">
                <Policy />
            </Route>
            <Route exact path="/login">
                <Login authenticated={LoginHelper.validateToken()} />
            </Route>
            <PrivateRoute exact path="/" component={Main} />
        </Router>
    );
}

export default App;
